import type { Oekt } from "../../state/session";
import * as oppsett from "../../state/oppsett";
import { DeltakereScreen } from "../DeltakereScreen";
import { IkkeDin, Topp } from "./deler";

/**
 * Oppsett · Innhold.
 *
 * Deltakerne. Redaktørens, med prodleder og produsent ved siden av.
 *
 * Selve lista er `DeltakereScreen` — den samme komponenten som står på sin
 * egen fane. Ett sted å vedlikeholde, og den som kommer hit første gang
 * møter nøyaktig det hen møter senere.
 */
export function OppsettInnhold({ oekt }: { readonly oekt: Oekt }): JSX.Element {
  if (!oppsett.minePunkter(oekt.member.role, oekt.member.extraRoles ?? []).includes("deltakere")) {
    return <IkkeDin />;
  }
  return (
    <div className="flate flate--oppsett">
      <div className="flate__innhold">
        <Topp
          tittel="Innhold"
          under={`${oekt.production.name} · deltakerne loggen viser til`}
        />
        <p className="merknad oppsett__bolktekst">
          Forkortelsen er det regi skriver i loggen. Kommer det nye deltakere
          senere, finner du den samme lista igjen her og på sin egen fane.
        </p>
        {/* DET ENESTE STEDET LISTA KAN ENDRES. Arbeidsflata viser den
            samme komponenten, men bare til lesing. */}
        <DeltakereScreen oekt={oekt} kanal="deltakere-oppsett" redigerbar />
      </div>
    </div>
  );
}
